import { Link } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const ASSET_BASE = process.env.PUBLIC_URL || "";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: "#1a1a1a",
        color: "grey.100",
        px: { xs: 3, md: 8 },
        pt: { xs: 6, md: 8 },
        pb: { xs: 4, md: 6 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: { xs: "flex-start", md: "flex-start" },
          justifyContent: "space-between",
          gap: 4,
        }}
      >
        <Box>
          <Typography
            variant="h1"
            sx={{
              fontSize: {
                xs: "2.5rem",
                sm: "3rem",
                md: "clamp(3.5rem, 5vw, 4.8rem)",
              },
              lineHeight: 1.02,
              fontWeight: 700,
              mb: 2.5,
              mt: 0,
            }}
          >
            We're on <br /> LinkedIn
          </Typography>
          <Button
            component="a"
            href="https://www.linkedin.com/company/kas-pty-ltd/"
            target="_blank"
            rel="noopener noreferrer"
            variant="outlined"
            sx={{
              borderColor: "grey.100",
              color: "grey.100",
              borderRadius: "20px 20px 0px 20px",
              px: 2.4,
              py: 0.875,
              fontSize: "0.95rem",
              gap: 1,
              transition: "all 0.3s ease",
              "&:hover": {
                "& .linkedin-icon": {
                  bgcolor: "#b7127e",
                  color: "common.white",
                },
              },
            }}
          >
            Let's engage{" "}
            <Box
              component="span"
              className="linkedin-icon"
              sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                width: 22,
                height: 22,
                borderRadius: "4px",
                bgcolor: "common.white",
                color: "grey.900",
                fontWeight: 700,
                fontSize: "0.8rem",
                transition: "all 0.3s ease", // Smooth color swap
              }}
            >
              in
            </Box>
          </Button>
        </Box>

        <Box
          component="img"
          src={`${ASSET_BASE}/assets/footerimg.png`}
          alt="Anko pattern"
          sx={{
            width: { xs: "100%", md: "min(44vw, 680px)" },
            maxWidth: { xs: "100%", md: "55%" },
            height: "auto",
            mr: { xs: 0, md: -8 },
          }}
        />
      </Box>

      <Box
        sx={{
          height: "2px",
          bgcolor: "#ffffff",
          opacity: 1,

          mx: { xs: -3, md: -8 },

          mt: { xs: 5, md: 6 },
          mb: { xs: 5, md: 6 },

          width: "auto",
        }}
      />

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1.2fr 1.5fr auto" },
          alignItems: "start",
          gap: 4,
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
          <Link to="/home" aria-label="Go to home">
            <Box
              component="img"
              src={`${ASSET_BASE}/assets/logofooter.png`}
              alt="Anko Sourcing"
              sx={{ width: { xs: 180, md: 200 }, height: "auto" }}
            />
          </Link>
          <Typography variant="caption" sx={{ color: "rgba(255,255,255,0.7)" }}>
            &copy; 2025 Anko Sourcing | All Rights Reserved
          </Typography>
        </Box>

        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "repeat(2,minmax(0,1fr))" },
            gap: { xs: 3, md: 8 },
            fontSize: "0.85rem",
            ml: { xs: 0, md: 16 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              color: "rgba(255,255,255,0.75)",
            }}
          >
            <Box
              component={Link}
              to="/careers"
              sx={{ color: "inherit", textDecoration: "none" }}
            >
              Careers
            </Box>
            <Box
              component={Link}
              to="/blogs"
              sx={{ color: "inherit", textDecoration: "none" }}
            >
              Blogs
            </Box>
            <Box
              component={Link}
              to="/about"
              sx={{ color: "inherit", textDecoration: "none" }}
            >
              About
            </Box>
          </Box>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              color: "rgba(255,255,255,0.75)",
            }}
          >
            <Box
              component="a"
              href="https://www.kmart.com.au/sourcingethically/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "inherit", textDecoration: "none" }}
            >
              Ethical Sourcing Policy
            </Box>
            <Box
              component="a"
              href="https://www.kmart.com.au/wcsstore/Kmart/pdfs/FY23KmartGroupWhistleblowerPolicyApril2024.pdf"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "inherit", textDecoration: "none" }}
            >
              Whistle-blower Policy
            </Box>
          </Box>
        </Box>

        <Button
          component={Link}
          to="/contact"
          variant="outlined"
          sx={{
            borderColor: "#b7127e",
            color: "#b7127e",
            bgcolor: "common.white",
            borderRadius: "20px 20px 0px 20px",
            px: 2.8,
            py: 0.8,
            fontWeight: 600,
            whiteSpace: "nowrap",
            width: { xs: "fit-content" },
            "&:hover": {
              bgcolor: "primary.main",
              color: "common.white",
              borderColor: "primary.main",
              borderWidth: "2px",
            },
          }}
        >
          Get in Touch
        </Button>
      </Box>
    </Box>
  );
}

export default Footer;
